import { actionGenerator } from '../../../utils/redux/actionGenerator';
import { TGetMenuFailed, EGetMenuActionType } from './types';

export const getMenuFailed: () => TGetMenuFailed = actionGenerator<EGetMenuActionType.Failed>(
  EGetMenuActionType.Failed,
);
